import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import ConfirmationBox from "../../../../components/common/ConfirmationBox";
import { months, packets, payee } from "../property";
import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import dayjs from "dayjs";

const OwnersAndFinancial = ({ data, dataId, companyName }) => {
  const [isEditActive, setIsEditActive] = useState(false);
  const [value, setValue] = useState("net income");
  const [newOwnerShipShow, setNewOwnerShipShow] = useState(false);

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const [owner, setOwners] = useState([]);

  useEffect(() => {
    const fetchOwners = async () => {
      try {
        const ownerRef = collection(db, "companies", companyName, "owners");
        const snapshot = await getDocs(ownerRef);
        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          value: doc.id,
          label:
            doc.data().ownerInfo.firstName +
            " " +
            doc.data().ownerInfo.lastName,
          ...doc.data(),
        }));
        setOwners(fetchedData);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchOwners();
  }, [companyName]);

  const onFinish = (values) => {
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const propertyDocRef = doc(companyDocRef, "properties", dataId);

    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });

    try {
      updateDoc(propertyDocRef, {
        ownerAndFinancials: {
          basisForOwnerPackets: values.basisForOwnerPackets,
          fiscalYearEnd: values.fiscalYearEnd,
          ownershipStartDate: values.ownershipStartDate ? values.ownershipStartDate.format("YYYY-MM-DD") : "",
          paymentType: values.paymentType,
          reservedFunds: values.reservedFunds,
          vendor1099: values.vendor1099,
        },
        "ownerAndFinancials.owners": accounts,
      });

      setIsEditActive(false);
    } catch (error) {
      console.error("not updated:", error);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const columns = [
    {
      title: "Owner",
      dataIndex: "owner",
      width: "70%",
      render: (_, record) => {
        const filteredOwners = owner.find((item) => item.id === record.ownerId);
        return (
          <p>
            {filteredOwners?.ownerInfo?.firstName}{" "}
            {filteredOwners?.ownerInfo?.lastName}
          </p>
        );
      },
    },
    {
      title: "Percent Owned",
      dataIndex: "percentOwned",
      render: (_, record) => <p>{record.percentOwned}</p>,
    },
    {
      title: "Contract Expiration",
      dataIndex: "contractExpires",
      render: (_, record) => <p>{record.contractExpires}</p>,
    },
  ];

  const [accounts, setAccounts] = useState([
    { id: uuidv4(), ownerId: "", percentOwned: "", contractExpires: "" },
  ]);

  useEffect(() => {
    if (companyName) {
      const fetchProperties = async () => {
        try {
          const PropertyRef = collection(
            db,
            "companies",
            companyName,
            "properties"
          );
          const snapshot = await getDocs(PropertyRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          const filteredProperty = fetchedData.find(
            (item) => item.id === dataId
          );
          setAccounts(
            filteredProperty?.ownerAndFinancials?.owners?.length >= 1
              ? filteredProperty?.ownerAndFinancials?.owners
              : [
                  {
                    id: uuidv4(),
                    ownerId: "",
                    percentOwned: "",
                    contractExpires: "",
                  },
                ]
          );
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchProperties();
    }
  }, [companyName, isEditActive]);

  const handleChange = (value, name, id) => {
    const updatedAccounts = accounts.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setAccounts(updatedAccounts);
  };

  const handleDateChange = (value, name, id) => {
    const updatedAccounts = accounts.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value.format("YYYY-MM-DD") };
      }
      return item;
    });
    setAccounts(updatedAccounts);
  };

  const addAccount = () => {
    const newAccount = {
      id: uuidv4(),
      ownerId: "",
      percentOwned: "",
      contractExpires: "",
    };
    setAccounts([...accounts, newAccount]);
  };

  const removeAccount = (id) => {
    const updatedAccounts = accounts.filter((item) => item.id !== id);
    setAccounts(updatedAccounts);
  };

  const initialValues = {
    ownershipStartDate: data?.ownershipStartDate
      ? dayjs(data?.ownershipStartDate, "YYYY-MM-DD")
      : null,
    paymentType: data?.paymentType || "net income",
    paymentAmount: data?.paymentAmount || "",
    reservedFunds: data?.reservedFunds || "",
    vendor1099: data?.vendor1099 || "",
    fiscalYearEnd: data?.fiscalYearEnd || "",
    basisForOwnerPackets: data?.basisForOwnerPackets || "",
  };

  return (
    <>
      <Card
        title="Owners and Financials"
        extra={
          <Button
            type="link"
            disabled={accounts.length > 0 ? true : false}
            onClick={() => setNewOwnerShipShow(true)}
          >
            New Ownership
          </Button>
        }
      >
        <Row justify="end">
          <Col>
            {!isEditActive ? (
              <Button
                type="link"
                onClick={() => {
                  setIsEditActive(true);
                }}
              >
                Edit
              </Button>
            ) : (
              ""
            )}
          </Col>
        </Row>
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          autoComplete="off"
          colon={false}
          initialValues={initialValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item label="Ownership Start Date" name="ownershipStartDate">
            {isEditActive ? (
              <DatePicker style={{ width: "50%" }} />
            ) : (
              <p>
                {data?.ownershipStartDate ? data?.ownershipStartDate : ""}
              </p>
            )}
          </Form.Item>
          {isEditActive ? (
            <ul>
              <Row>
                <Col className="tableHead" span={12}>
                  <p>Owner</p>
                </Col>
                <Col className="tableHead" span={6}>
                  <p>Percent Owned</p>
                </Col>
                <Col className="tableHead" span={5}>
                  <p>Contract Expires</p>
                </Col>
                <Col span={1}></Col>
              </Row>
              {accounts.map((item) => (
                <li key={item.id}>
                  <Form.Item>
                    <Row>
                      <Col span={12}>
                        <Form.Item label="">
                          <Select
                            showSearch
                            style={{ width: "100%" }}
                            options={owner}
                            value={item.ownerId} // Set the initial value based on ownerId
                            onChange={(value) =>
                              handleChange(value, "ownerId", item.id)
                            }
                            optionLabelProp="label" // Use the "label" property as the display label in the options
                          >
                            {owner.map((option) => (
                              <Select.Option
                                key={option.value}
                                value={option.value}
                                label={option.label}
                              >
                                {option.label}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item label="">
                          <InputNumber
                            min={0}
                            max={100}
                            formatter={(value) => `${value}%`}
                            parser={(value) => value.replace("%", "")}
                            suffix={<i className="fa-solid fa-percent"></i>}
                            style={{ width: "100%" }}
                            value={item.percentOwned}
                            onChange={(value) =>
                              handleChange(value, "percentOwned", item.id)
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={5}>
                        <Form.Item label="">
                          <DatePicker
                            style={{ width: "100%" }}
                            value={
                              item.contractExpires
                                ? dayjs(item.contractExpires)
                                : ""
                            }
                            onChange={(value) =>
                              handleDateChange(
                                value,
                                "contractExpires",
                                item.id
                              )
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={1}>
                        {accounts.length > 1 ? (
                          <Button
                            className="roundSmallButton"
                            onClick={() => {
                              removeAccount(item.id);
                            }}
                            type="primary"
                            shape="circle"
                            icon={
                              <i className="fa-sharp fa-solid fa-xmark"></i>
                            }
                            size={"small"}
                          />
                        ) : (
                          <></>
                        )}
                      </Col>
                    </Row>
                  </Form.Item>
                </li>
              ))}

              <Form.Item label="">
                <Button
                  className="addPropertyGroupButton"
                  type="primary"
                  onClick={addAccount}
                  size={"small"}
                  icon={<i className="fa-solid fa-circle-plus"></i>}
                  style={{ width: "100%" }}
                >
                  Add Another Owner
                </Button>
              </Form.Item>
            </ul>
          ) : (
            <Table
              columns={columns}
              dataSource={accounts}
              size="small"
              rowKey={(obj) => obj.key}
              pagination={false}
            />
          )}
          {isEditActive && (
            <Form.Item label=" ">
              <p>Total: 0%</p>
            </Form.Item>
          )}
          <Form.Item label="Payment Type" name="paymentType">
            {isEditActive ? (
              <Radio.Group>
                <Space direction="horizontal">
                  <Radio value="net income">Net Income</Radio>
                  <Radio value="Flat">Flat</Radio>
                </Space>
              </Radio.Group>
            ) : (
              <p>{data?.paymentType === "" ? "--" : data?.paymentType}</p>
            )}
          </Form.Item>
          <Form.Item
            label="Reserve Funds"
            required={isEditActive ? true : false}
            name="reservedFunds"
          >
            {isEditActive ? (
              <Input type="Number" prefix="$" />
            ) : (
              <p>{data?.reservedFunds === "" ? "--" : data?.reservedFunds}</p>
            )}
          </Form.Item>
          <Form.Item label="Vendor 1099 Payer" name="vendor1099">
            {isEditActive ? (
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "Use Portfolio (Integrity Oklahoma LLC)",
                  },
                  {
                    value: "Casa Rentals LLC",
                  },
                ]}
              />
            ) : (
              <p>{data?.vendor1099 === "" ? "--" : data?.vendor1099}</p>
            )}
          </Form.Item>
          <Form.Item label="Fiscal Year End" name="fiscalYearEnd">
            {isEditActive ? (
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "January",
                  },
                  {
                    value: "February",
                  },
                  {
                    value: "March",
                  },
                  {
                    value: "April",
                  },
                  {
                    value: "May",
                  },
                  {
                    value: "June",
                  },
                  {
                    value: "July",
                  },
                  {
                    value: "August",
                  },
                  {
                    value: "September",
                  },
                  {
                    value: "October",
                  },
                  {
                    value: "November",
                  },
                  {
                    value: "December",
                  },
                ]}
              />
            ) : (
              <p>{data?.fiscalYearEnd === "" ? "--" : data?.fiscalYearEnd}</p>
            )}
          </Form.Item>
          <Form.Item
            label="Basis for Owner Packets"
            name="basisForOwnerPackets"
          >
            {isEditActive ? (
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "Cash",
                  },
                  {
                    value: "Accrual",
                  },
                ]}
              />
            ) : (
              <p>
                {data?.basisForOwnerPackets === ""
                  ? "--"
                  : data?.basisForOwnerPackets}
              </p>
            )}
          </Form.Item>
          {isEditActive && (
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit">
                  Save
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
      {newOwnerShipShow && (
        <ConfirmationBox setIsConfirmationBoxOpen={setNewOwnerShipShow}>
          <h2>New Ownership</h2>
          <Form labelCol={{ span: 8 }} wrapperCol={{ span: 11 }} colon={false}>
            <Row className="new-ownership" gutter={[0, 8]}>
              <Col span={24}>
                <Form.Item label="Ownership Start Date" required>
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Row>
                  <Col span={22}>
                    <Row className="header-row">
                      <Col span={8}>
                        <span>Owner</span>
                      </Col>
                      <Col span={8}>
                        <span>Percent Owned</span>
                      </Col>
                      <Col span={6}>
                        <span>Contract Expires</span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <p className="center-text">Total: 0%</p>
              </Col>
              <Col span={24}>
                <p className="onclick-text">Create New Owner</p>
              </Col>
              <Col span={24}>
                <Form.Item label="Payment Type">
                  <Radio.Group onChange={onChange} value={value}>
                    <Radio value="net income">Net Income</Radio>
                    <Radio value="flat">Flat</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Reserve Funds" required>
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder="Reserve Funds"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Vendor 1099 Payer">
                  <Select options={payee} placeholder="Select" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Fiscal Year End">
                  <Select options={months} placeholder="Select" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Basis for Owner Packets">
                  <Select options={packets} placeholder="Select" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div className="action-buttons">
            <Button type="primary" onClick={() => setNewOwnerShipShow(false)}>
              Save
            </Button>
            <button
              className="cancel-btn"
              onClick={() => setNewOwnerShipShow(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      )}
    </>
  );
};

export default OwnersAndFinancial;
